import React from 'react';
import ReactMarkdown from 'react-markdown';

import { AiAssistantDisclaimerKey, aiAssistantDisclaimers } from './ai-assistant-disclaimers';

type Props = {
  assistant: AiAssistantDisclaimerKey;
  className?: string;
};

export const AiAssistantDisclaimer = ({ assistant, className }: Props) => {
  const disclaimer = aiAssistantDisclaimers[assistant];
  if (!disclaimer) {
    return null;
  }

  return (
    <div
      className={`mt-5 rounded-[12px] bg-[#F6F6F6] p-4 text-xs lg:text-sm text-greyBase leading-relaxed ${
        className ?? ''
      }`}
    >
      <ReactMarkdown
        components={{
          p: (paragraphProps) => <p className="mt-3 mb-1 last:mb-0" {...paragraphProps} />,
        }}
      >
        {disclaimer}
      </ReactMarkdown>
    </div>
  );
};
